/* eslint-disable generator-star-spacing */
/* eslint space-before-function-paren: "off" */

import { SagaIterator } from 'redux-saga'
import { all, AllEffect } from 'redux-saga/effects'

import authSaga from './auth/saga'
import campaignsSaga from './campaigns/saga'
import clientSaga from './client/saga'
import clientPropertiesSaga from './clientProperties/saga'
import clientsSaga from './clients/saga'
import commentsSaga from './comments/saga'
import communicationsSaga from './communications/saga'
import companiesSaga from './companies/saga'
import companySaga from './company/saga'
import discountsSaga from './discounts/saga'
import employeeSaga from './employee/saga'
import employeesSaga from './employees/saga'
import estimateSaga from './estimate/saga'
import estimateItemsSaga from './estimateItems/saga'
import estimatesSaga from './estimates/saga'
import estimatesByCategorySaga from './estimatesByCategory/saga'
import filesSaga from './files/saga'
import groupedOrdersSaga from './groupedOrders/saga'
import historySaga from './history/saga'
import homemartSaga from './homemart/saga'
import inspectionCompaniesSaga from './inspectionCompanies/saga'
import inspectionCompanySaga from './inspectionCompany/saga'
import inspectionReportsSaga from './inspectionReports/saga'
import inspectorsSaga from './inspectors/saga'
import insurancesSaga from './insurances/saga'
import invitationsSaga from './invitations/saga'
import invoiceSaga from './invoice/saga'
import itemsSaga from './items/saga'
import jobSaga from './job/saga'
import jobsSaga from './jobs/saga'
import licensesSaga from './licenses/saga'
import matchSaga from './match/saga'
import matchesSaga from './matches/saga'
import materialSaga from './material/saga'
import materialInvoicesSaga from './materialInvoice/saga'
import materialsSaga from './materials/saga'
import navbarSaga from './navBar/saga'
import newEstimateSaga from './newEstimate/saga'
import notesSaga from './notes/saga'
import notificationsSaga from './notifications/saga'
import orderSaga from './order/saga'
import ordersSaga from './orders/saga'
import paymentsSaga from './payments/saga'
import pcViewSaga from './pc-view/saga'
import priceModelSaga from './priceModels/saga'
import promoCodesSaga from './promoCodes/saga'
import repairItemSaga from './repairItem/saga'
import repairListSaga from './repairList/saga'
import reportsSaga from './reports/saga'
import searchesSaga from './searches/saga'
import siteVisitSaga from './siteVisit/saga'
import siteVisitsSaga from './siteVisits/saga'
import subscriptionSaga from './subscription/saga'
import subscriptionsSaga from './subscriptions/saga'
import territoriesSaga from './territories/saga'
import territorySaga from './territory/saga'
import tradeTypesSaga from './tradeTypes/saga'
import vendorSaga from './vendor/saga'
import vendorsSaga from './vendors/saga'
import widgetSaga from './widget/saga'
import widgetsSaga from './widgets/saga'
import workOrdersSaga from './work-orders/saga'
import workflowsSaga from './workflows/saga'

const rootSaga = function* rootSaga(): Generator<
  AllEffect<SagaIterator<any>>,
  void,
  unknown
> {
  yield all([
    authSaga(),
    clientSaga(),
    clientPropertiesSaga(),
    clientsSaga(),
    employeeSaga(),
    orderSaga(),
    ordersSaga(),
    vendorSaga(),
    vendorsSaga(),
    searchesSaga(),
    siteVisitSaga(),
    siteVisitsSaga(),
    promoCodesSaga(),
    territoriesSaga(),
    jobSaga(),
    jobsSaga(),
    licensesSaga(),
    companiesSaga(),
    companySaga(),
    itemsSaga(),
    territorySaga(),
    workflowsSaga(),
    filesSaga(),
    notificationsSaga(),
    commentsSaga(),
    employeesSaga(),
    notesSaga(),
    invoiceSaga(),
    paymentsSaga(),
    tradeTypesSaga(),
    communicationsSaga(),
    navbarSaga(),
    materialInvoicesSaga(),
    historySaga(),
    priceModelSaga(),
    estimatesSaga(),
    estimatesByCategorySaga(),
    estimateSaga(),
    invitationsSaga(),
    subscriptionsSaga(),
    subscriptionSaga(),
    insurancesSaga(),
    newEstimateSaga(),
    estimateItemsSaga(),
    widgetsSaga(),
    widgetSaga(),
    matchesSaga(),
    matchSaga(),
    repairListSaga(),
    repairItemSaga(),
    materialSaga(),
    materialsSaga(),
    groupedOrdersSaga(),
    discountsSaga(),
    reportsSaga(),
    campaignsSaga(),
    homemartSaga(),
    workOrdersSaga(),
    pcViewSaga(),
    inspectionCompaniesSaga(),
    inspectionCompanySaga(),
    inspectorsSaga(),
    inspectionReportsSaga(),
  ])
}

export default rootSaga
